import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import { Link } from 'react-router';
import 'animate.css/animate.css';
import Logo from '../common/Logo';
import CustomButton from '../common/CustomButton';
import * as accountActions from '../../actions/accountActions';
import routerHistory from '../../routerHistory';
import * as componentActions from '../../actions/componentActions';

import $ from 'jquery';
import { getSkinFromStorageOrDefault } from '../../shared';
import { ROUTES } from '../../const';

class Forget extends React.Component {
  constructor(props) {
    super(props);
    this.newPasswordHandler = this.newPasswordHandler.bind(this);
  }

  static propTypes = {};

  componentDidMount() {
    const { accountActions } = this.props;

    $('#wrapperBackground').addClass('background-color-opaque-opacity');
    accountActions.setIndexTransition(true);
  }

  newPasswordHandler(e) {
    e.preventDefault();
    const { isAppOnline } = this.props;
    if (isAppOnline) {
      const { accountActions, componentActions } = this.props;
      let email = this.refs.username.value;

      if (this.validateEmail(email)) {
        componentActions.isFetching(true);
        accountActions
          .requestNewPassword(email)
          .then(() => {
            routerHistory.push(ROUTES.LOGIN_SENT);
          })
          .catch(() => {
            routerHistory.push(ROUTES.LOGIN_SURE);
          });
      }
    }
  }

  validateEmail(email) {
    let { accountActions } = this.props;
    let regex = /^.+@.+\..+$/;
    if (!regex.test(email)) {
      accountActions.setFormError(I18n.t('register.emailError'));
      this.refs.username.className = 'error-input';
      return false;
    }
    accountActions.setFormError('');
    this.refs.username.className = '';
    return true;
  }

  formErrorHandler() {
    const { signUp } = this.props;
    return (
      <div className="error expand large-12 small-12 column text-center">
        <span>{signUp.formError}</span>
      </div>
    );
  }

  render() {
    let theme = getSkinFromStorageOrDefault();
    let colors = theme.colors;

    return (
      <div className="column xlarge-6 large-8 medium-10 small-12 content align-center">
        <div className="row box background-color-opaque align-center" id="wrapperBackground">
          <div className="row small-12 align-top">
            <div className="column">
              <div className="column small-12 text-center">
                <Logo customCss="logo-opaque" />
              </div>
              <h4 className="columns medium-12 text-center">{I18n.t('forget.title')}</h4>
              <p className="columns medium-12 text-center p-32-top-margin">{I18n.t('forget.text')}</p>
              {this.formErrorHandler()}
              <form onSubmit={this.newPasswordHandler}>
                <div className="column xlarge-offset-2 xlarge-8 large-offset-3 large-6 medium-offset-2 medium-8 small-12">
                  <input id="username" type="email" ref="username" placeholder={I18n.t('forget.email')} />
                  <CustomButton
                    id="forget-button"
                    className="button secondary expanded"
                    value={I18n.t('common.submit')}
                    disabled={false}
                    color={colors.btnSuccess}
                    colorHover={colors.btnSuccessHover}
                  />
                </div>
              </form>
            </div>
          </div>

          <div className="row align-self-bottom text-center">
            <Link to={ROUTES.LOGIN}>
              <p className="bottom-link"> {I18n.t('common.backToLogin')}</p>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.account.user,
    signUp: state.signUp,
    i18n: state.i18n,
    isAppOnline: state.connection.status.online
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    componentActions: bindActionCreators(componentActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Forget);
